import React, {useState, useEffect, useRef, lazy, Suspense} from "react"
import Loading from "../../components/Loading";
import {
    verifyTicketScanData,
    decodeTicketQRCodeData,
    //the product specific functions are here
    getVerificationsAndQuantityFromLineItem,
    getDeterministicVerificationIdFromLineItem
} from "../../utils/ticketUtils"
import { retryLazy } from "../../utils/applicationUtils";

import withResultModal from "../../hocs/withResultModal"

import ErrorBoundary from "../../components/ErrorBoundary";
import { OBJECT_TYPE_TICKET } from "../../constants/ticket";
import { OBJECT_TYPE_RECEIPT } from "../../constants/receipts";
// Wrap your lazy loading with retry logic
const QRCodeScanner = lazy(() =>
  retryLazy(() => import("../../components/QRCodeScanner"))
);

const TicketEntryScanner = ({
    payeeId="", //the payee merchant account to be considered valid during scans
    setResult=()=>{},
    setResultMessage=()=>{},
    setResultOptions=()=>{},
    receiptCustomValidate=null, // a custom validation function to be used during scanning, passed to the digital receipt scanning flow only
    receiptsById={}, //a map of receipts to be considered during scanning
    ticketsById={}, //a map of tickets to be considered during scanning
    onVerify=(verificationId, scanData, objectType)=>{}
}) => {
    /**
     * Scan QR codes on digital or physical tickets to validate them
     */

    //store the receipt scan data
    const [scanData, setScanData] = useState(null)
    const scanInProgressRef = useRef(false); // Ref to block scanning
    const checkScanData = () => {
        console.log("beginning check receipt")
        let results
        let {objectType=""} = scanData || {}
        //if this is a ticket object (most likely a physical ticket)
        if (objectType === OBJECT_TYPE_TICKET){
            //do the standard generic verification 
            results = verifyTicketScanData(
                scanData,
                ticketsById,
                OBJECT_TYPE_TICKET,
                payeeId,
            )
        } else {
            //if the object type is something else or is not specified
            //then we assume it is a receipt, this allows backwards compatibility, otherwise it will fail
            objectType = OBJECT_TYPE_RECEIPT
            results = verifyTicketScanData(
                scanData,
                receiptsById,
                OBJECT_TYPE_RECEIPT,
                payeeId,
                receiptCustomValidate,
                getVerificationsAndQuantityFromLineItem,
                getDeterministicVerificationIdFromLineItem
            )
        }
        const {success=false, result, resultMessage, verificationId} = results || {}
        if (success) {
            console.log(`SUCCESS ${verificationId}`)
            onVerify(verificationId, scanData, objectType)
        }
        //display result
        setResult(result)
        setResultMessage(resultMessage)
        //reset the camera when the result screen is closed
        setResultOptions({
            onClose: ()=>{
                console.log(`closing ${verificationId}`);
                setScanData(null);
                scanInProgressRef.current = false; // Allow scanning again
            }
        })
    }
    //process scan data after scanning the receipt
    useEffect(() => {
        if (scanData){
            checkScanData()
        }
    }, [scanData])
    return (
        <div>
            <div className="h2 text-align-center margin-bottom-05em display-flex justify-content-center align-items-center" >
               Scan Ticket QR Code
            </div>
            <div className="display-flex justify-content-center align-items-center margin-bottom-05em">
                <ErrorBoundary
                    errorHeading="Sorry, we could not load the scanner. Check your internet connection and retry"
                    errorContext="TicketEntryScanner Lazy-Loading"
                >
                <Suspense fallback={<Loading />}>
                    <div style={{
                        height: "100%",
                        width: "fit-content"
                    }}>
                        <QRCodeScanner 
                            onScan={data => {
                                if (!scanInProgressRef.current) {
                                    console.log("about to set scan data");
                                    scanInProgressRef.current = true; // Block further scans immediately
                                    setScanData(decodeTicketQRCodeData(data));
                                }
                            }}
                            isActive={!scanData} //pause or restart the camera
                        />
                    </div>
                </Suspense>
                </ErrorBoundary>
            </div>
        </div>
    )
}

export default withResultModal(TicketEntryScanner)